import { Directive, HostListener, Input, ElementRef } from '@angular/core';
import { NgControl } from '@angular/forms';

/**
 * Strips non-digits and caps length on an input.
 *
 * The API stores contact.PhoneNumber as nvarchar(20). An oversized value throws a truncation
 * error mid-submit, after the card has already been charged, which strands the donation.
 */
@Directive({
  selector: '[appDigitsOnly]'
})
export class DigitsOnlyDirective {
  @Input() maxDigits = 20;

  constructor(private el: ElementRef<HTMLInputElement>, private control: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    this.sanitise((event.target as HTMLInputElement).value);
  }

  // Paste fires before the value lands, so re-read on the next tick.
  @HostListener('paste')
  onPaste(): void {
    setTimeout(() => this.sanitise(this.el.nativeElement.value));
  }

  @HostListener('blur')
  onBlur(): void {
    this.sanitise(this.el.nativeElement.value);
  }

  private sanitise(raw: string): void {
    const cleaned = (raw || '').replace(/\D/g, '').slice(0, this.maxDigits);
    if (this.el.nativeElement.value !== cleaned) {
      this.el.nativeElement.value = cleaned;
    }
    // Checked separately from the DOM: the form's own input listener may run after this one
    // and write the raw value back into the control.
    const control = this.control?.control;
    if (control && (control.value ?? '') !== cleaned) {
      // emitEvent:false avoids re-entering this handler.
      control.setValue(cleaned, { emitEvent: false });
    }
  }
}
